/* eslint-disable max-lines */

import { useSelector } from "react-redux";

import { getMarketInfo } from "@gamedev-web/gamedev-sdk-core";

import { useStrings } from "../localization/localizationHelpers";
import { getCountriesOrRegionsList } from "../redux/selectors";
import { FieldOption } from "../server/crm/api/models/forms";
import { countryCrmCodeToIso } from "../server/crm/api/utils/countryCrmCodeToIso";
import { DropdownOption } from "./optionSets";

export const useLocalizedCountriesOrRegionsList = (
  crmCountriesOrRegionsList: ReadonlyArray<FieldOption> | undefined,
  includeSelect = true
): Array<DropdownOption> => {
  const [
    select,
    afghanistan,
    albania,
    algeria,
    americanSamoa,
    andorra,
    angola,
    anguilla,
    antarctica,
    antiguaAndBarbuda,
    argentina,
    armenia,
    aruba,
    australia,
    austria,
    azerbaijan,
    bahamasThe,
    bahrain,
    bangladesh,
    barbados,
    belarus,
    belgium,
    belize,
    benin,
    bermuda,
    bhutan,
    bolivia,
    bosniaAndHerzegovina,
    botswana,
    bouvetIsland,
    brazil,
    britishIndianOceanTerritory,
    brunei,
    bulgaria,
    burkinaFaso,
    burundi,
    cambodia,
    cameroon,
    canada,
    capeVerde,
    caymanIslands,
    centralAfricanRepublic,
    chad,
    chile,
    china,
    christmasIsland,
    cocosIslands,
    colombia,
    comoros,
    congo,
    congoDrc,
    cookIslands,
    costaRica,
    coteDivoire,
    croatia,
    cuba,
    cyprus,
    czechRepublic,
    denmark,
    djibouti,
    dominica,
    dominicanRepublic,
    ecuador,
    egypt,
    elSalvador,
    equatorialGuinea,
    eritrea,
    estonia,
    ethiopia,
    falklandIslands,
    faroeIslands,
    fijiIslands,
    finland,
    france,
    frenchGuiana,
    frenchPolynesia,
    frenchSouthernAndAntarcticLands,
    gabon,
    gambiaThe,
    georgia,
    germany,
    ghana,
    gibraltar,
    greece,
    greenland,
    grenada,
    guadeloupe,
    guam,
    guatemala,
    guernsey,
    guinea,
    guineaBissau,
    guyana,
    haiti,
    heardIslandAndMcdonaldIslands,
    honduras,
    hongKongSar,
    hungary,
    iceland,
    india,
    indonesia,
    iran,
    iraq,
    ireland,
    isleOfMan,
    israel,
    italy,
    jamaica,
    japan,
    jersey,
    jordan,
    kazakhstan,
    kenya,
    kiribati,
    korea,
    kuwait,
    kyrgyzstan,
    laos,
    latvia,
    lebanon,
    lesotho,
    liberia,
    libya,
    liechtenstein,
    lithuania,
    luxembourg,
    macaoSar,
    madagascar,
    malawi,
    malaysia,
    maldives,
    mali,
    malta,
    marshallIslands,
    martinique,
    mauritania,
    mauritius,
    mayotte,
    mexico,
    micronesia,
    moldova,
    monaco,
    mongolia,
    montenegro,
    montserrat,
    morocco,
    mozambique,
    myanmar,
    namibia,
    nauru,
    nepal,
    netherlands,
    netherlandsAntilles,
    newCaledonia,
    newZealand,
    nicaragua,
    niger,
    nigeria,
    niue,
    norfolkIsland,
    northKorea,
    northMacedonia,
    northernMarianaIslands,
    norway,
    oman,
    pakistan,
    palau,
    palestinianAuthority,
    panama,
    papuaNewGuinea,
    paraguay,
    peru,
    philippines,
    pitcairnIslands,
    poland,
    portugal,
    puertoRico,
    qatar,
    reunion,
    romania,
    russia,
    rwanda,
    saintHelena,
    saintKittsAndNevis,
    saintLucia,
    saintPierreAndMiquelon,
    saintVincentAndTheGrenadines,
    samoa,
    sanMarino,
    saoTomeAndPrincipe,
    saudiArabia,
    senegal,
    serbia,
    seychelles,
    sierraLeone,
    singapore,
    slovakia,
    slovenia,
    solomonIslands,
    somalia,
    southAfrica,
    southGeorgia,
    spain,
    sriLanka,
    sudan,
    suriname,
    svalbard,
    swaziland,
    sweden,
    switzerland,
    syria,
    taiwan,
    tajikistan,
    tanzania,
    thailand,
    timorLeste,
    togo,
    tokelau,
    tonga,
    trinidadAndTobago,
    tunisia,
    turkey,
    turkmenistan,
    turksAndCaicosIslands,
    tuvalu,
    usMinorOutlyingIslands,
    uganda,
    ukraine,
    unitedArabEmirates,
    unitedKingdom,
    unitedStates,
    uruguay,
    uzbekistan,
    vanuatu,
    vaticanCity,
    venezuela,
    vietnam,
    virginIslandsBritish,
    virginIslandsUs,
    wallisAndFutuna,
    yemen,
    zambia,
    zimbabwe,
  ] = useStrings(
    "select",
    "afghanistan",
    "albania",
    "algeria",
    "americanSamoa",
    "andorra",
    "angola",
    "anguilla",
    "antarctica",
    "antiguaAndBarbuda",
    "argentina",
    "armenia",
    "aruba",
    "australia",
    "austria",
    "azerbaijan",
    "bahamasThe",
    "bahrain",
    "bangladesh",
    "barbados",
    "belarus",
    "belgium",
    "belize",
    "benin",
    "bermuda",
    "bhutan",
    "bolivia",
    "bosniaAndHerzegovina",
    "botswana",
    "bouvetIsland",
    "brazil",
    "britishIndianOceanTerritory",
    "brunei",
    "bulgaria",
    "burkinaFaso",
    "burundi",
    "cambodia",
    "cameroon",
    "canada",
    "capeVerde",
    "caymanIslands",
    "centralAfricanRepublic",
    "chad",
    "chile",
    "china",
    "christmasIsland",
    "cocosIslands",
    "colombia",
    "comoros",
    "congo",
    "congoDrc",
    "cookIslands",
    "costaRica",
    "coteDivoire",
    "croatia",
    "cuba",
    "cyprus",
    "czechRepublic",
    "denmark",
    "djibouti",
    "dominica",
    "dominicanRepublic",
    "ecuador",
    "egypt",
    "elSalvador",
    "equatorialGuinea",
    "eritrea",
    "estonia",
    "ethiopia",
    "falklandIslands",
    "faroeIslands",
    "fijiIslands",
    "finland",
    "france",
    "frenchGuiana",
    "frenchPolynesia",
    "frenchSouthernAndAntarcticLands",
    "gabon",
    "gambiaThe",
    "georgia",
    "germany",
    "ghana",
    "gibraltar",
    "greece",
    "greenland",
    "grenada",
    "guadeloupe",
    "guam",
    "guatemala",
    "guernsey",
    "guinea",
    "guineaBissau",
    "guyana",
    "haiti",
    "heardIslandAndMcdonaldIslands",
    "honduras",
    "hongKongSar",
    "hungary",
    "iceland",
    "india",
    "indonesia",
    "iran",
    "iraq",
    "ireland",
    "isleOfMan",
    "israel",
    "italy",
    "jamaica",
    "japan",
    "jersey",
    "jordan",
    "kazakhstan",
    "kenya",
    "kiribati",
    "korea",
    "kuwait",
    "kyrgyzstan",
    "laos",
    "latvia",
    "lebanon",
    "lesotho",
    "liberia",
    "libya",
    "liechtenstein",
    "lithuania",
    "luxembourg",
    "macaoSar",
    "madagascar",
    "malawi",
    "malaysia",
    "maldives",
    "mali",
    "malta",
    "marshallIslands",
    "martinique",
    "mauritania",
    "mauritius",
    "mayotte",
    "mexico",
    "micronesia",
    "moldova",
    "monaco",
    "mongolia",
    "montenegro",
    "montserrat",
    "morocco",
    "mozambique",
    "myanmar",
    "namibia",
    "nauru",
    "nepal",
    "netherlands",
    "netherlandsAntilles",
    "newCaledonia",
    "newZealand",
    "nicaragua",
    "niger",
    "nigeria",
    "niue",
    "norfolkIsland",
    "northKorea",
    "northMacedonia",
    "northernMarianaIslands",
    "norway",
    "oman",
    "pakistan",
    "palau",
    "palestinianAuthority",
    "panama",
    "papuaNewGuinea",
    "paraguay",
    "peru",
    "philippines",
    "pitcairnIslands",
    "poland",
    "portugal",
    "puertoRico",
    "qatar",
    "reunion",
    "romania",
    "russia",
    "rwanda",
    "saintHelena",
    "saintKittsAndNevis",
    "saintLucia",
    "saintPierreAndMiquelon",
    "saintVincentAndTheGrenadines",
    "samoa",
    "sanMarino",
    "saoTomeAndPrincipe",
    "saudiArabia",
    "senegal",
    "serbia",
    "seychelles",
    "sierraLeone",
    "singapore",
    "slovakia",
    "slovenia",
    "solomonIslands",
    "somalia",
    "southAfrica",
    "southGeorgia",
    "spain",
    "sriLanka",
    "sudan",
    "suriname",
    "svalbard",
    "swaziland",
    "sweden",
    "switzerland",
    "syria",
    "taiwan",
    "tajikistan",
    "tanzania",
    "thailand",
    "timorLeste",
    "togo",
    "tokelau",
    "tonga",
    "trinidadAndTobago",
    "tunisia",
    "turkey",
    "turkmenistan",
    "turksAndCaicosIslands",
    "tuvalu",
    "usMinorOutlyingIslands",
    "uganda",
    "ukraine",
    "unitedArabEmirates",
    "unitedKingdom",
    "unitedStates",
    "uruguay",
    "uzbekistan",
    "vanuatu",
    "vaticanCity",
    "venezuela",
    "vietnam",
    "virginIslandsBritish",
    "virginIslandsUs",
    "wallisAndFutuna",
    "yemen",
    "zambia",
    "zimbabwe"
  );

  const countryIsoToLocalizedName: Readonly<Record<string, string>> = {
    AF: afghanistan,
    AL: albania,
    AQ: antarctica,
    DZ: algeria,
    AS: americanSamoa,
    AD: andorra,
    AO: angola,
    AG: antiguaAndBarbuda,
    AZ: azerbaijan,
    AR: argentina,
    AU: australia,
    AT: austria,
    BS: bahamasThe,
    BH: bahrain,
    BD: bangladesh,
    AM: armenia,
    BB: barbados,
    BE: belgium,
    BM: bermuda,
    BT: bhutan,
    BO: bolivia,
    BA: bosniaAndHerzegovina,
    BW: botswana,
    BV: bouvetIsland,
    BR: brazil,
    BZ: belize,
    IO: britishIndianOceanTerritory,
    SB: solomonIslands,
    VG: virginIslandsBritish,
    BN: brunei,
    BG: bulgaria,
    MM: myanmar,
    BI: burundi,
    BY: belarus,
    KH: cambodia,
    CM: cameroon,
    CA: canada,
    CV: capeVerde,
    KY: caymanIslands,
    CF: centralAfricanRepublic,
    LK: sriLanka,
    TD: chad,
    CL: chile,
    CN: china,
    TW: taiwan,
    CX: christmasIsland,
    CC: cocosIslands,
    CO: colombia,
    KM: comoros,
    YT: mayotte,
    CG: congo,
    CD: congoDrc,
    CK: cookIslands,
    CR: costaRica,
    HR: croatia,
    CU: cuba,
    CY: cyprus,
    CZ: czechRepublic,
    BJ: benin,
    DK: denmark,
    DM: dominica,
    DO: dominicanRepublic,
    EC: ecuador,
    SV: elSalvador,
    GQ: equatorialGuinea,
    ET: ethiopia,
    ER: eritrea,
    EE: estonia,
    FO: faroeIslands,
    FK: falklandIslands,
    GS: southGeorgia,
    FJ: fijiIslands,
    FI: finland,
    FR: france,
    GF: frenchGuiana,
    PF: frenchPolynesia,
    TF: frenchSouthernAndAntarcticLands,
    DJ: djibouti,
    GA: gabon,
    GE: georgia,
    GM: gambiaThe,
    PS: palestinianAuthority,
    DE: germany,
    GH: ghana,
    GI: gibraltar,
    KI: kiribati,
    GR: greece,
    GL: greenland,
    GD: grenada,
    GP: guadeloupe,
    GU: guam,
    GT: guatemala,
    GN: guinea,
    GY: guyana,
    HT: haiti,
    HM: heardIslandAndMcdonaldIslands,
    VA: vaticanCity,
    HN: honduras,
    HK: hongKongSar,
    HU: hungary,
    IS: iceland,
    IN: india,
    ID: indonesia,
    IR: iran,
    IQ: iraq,
    IE: ireland,
    IL: israel,
    IT: italy,
    CI: coteDivoire,
    JM: jamaica,
    JP: japan,
    KZ: kazakhstan,
    JO: jordan,
    KE: kenya,
    KP: northKorea,
    KR: korea,
    KW: kuwait,
    KG: kyrgyzstan,
    LA: laos,
    LB: lebanon,
    LS: lesotho,
    LV: latvia,
    LR: liberia,
    LY: libya,
    LI: liechtenstein,
    LT: lithuania,
    LU: luxembourg,
    MO: macaoSar,
    MG: madagascar,
    MW: malawi,
    MY: malaysia,
    MV: maldives,
    ML: mali,
    MT: malta,
    MQ: martinique,
    MR: mauritania,
    MU: mauritius,
    MX: mexico,
    MC: monaco,
    MN: mongolia,
    MD: moldova,
    ME: montenegro,
    MS: montserrat,
    MA: morocco,
    MZ: mozambique,
    OM: oman,
    NA: namibia,
    NR: nauru,
    NP: nepal,
    NL: netherlands,
    AN: netherlandsAntilles,
    AW: aruba,
    NC: newCaledonia,
    VU: vanuatu,
    NZ: newZealand,
    NI: nicaragua,
    NE: niger,
    NG: nigeria,
    NU: niue,
    NF: norfolkIsland,
    NO: norway,
    MP: northernMarianaIslands,
    UM: usMinorOutlyingIslands,
    FM: micronesia,
    MH: marshallIslands,
    PW: palau,
    PK: pakistan,
    PA: panama,
    PG: papuaNewGuinea,
    PY: paraguay,
    PE: peru,
    PH: philippines,
    PN: pitcairnIslands,
    PL: poland,
    PT: portugal,
    GW: guineaBissau,
    TL: timorLeste,
    PR: puertoRico,
    QA: qatar,
    RE: reunion,
    RO: romania,
    RU: russia,
    RW: rwanda,
    SH: saintHelena,
    KN: saintKittsAndNevis,
    AI: anguilla,
    LC: saintLucia,
    PM: saintPierreAndMiquelon,
    VC: saintVincentAndTheGrenadines,
    SM: sanMarino,
    ST: saoTomeAndPrincipe,
    SA: saudiArabia,
    SN: senegal,
    RS: serbia,
    SC: seychelles,
    SL: sierraLeone,
    SG: singapore,
    SK: slovakia,
    VN: vietnam,
    SI: slovenia,
    SO: somalia,
    ZA: southAfrica,
    ZW: zimbabwe,
    ES: spain,
    SD: sudan,
    SR: suriname,
    SJ: svalbard,
    SZ: swaziland,
    SE: sweden,
    CH: switzerland,
    SY: syria,
    TJ: tajikistan,
    TH: thailand,
    TG: togo,
    TK: tokelau,
    TO: tonga,
    TT: trinidadAndTobago,
    AE: unitedArabEmirates,
    TN: tunisia,
    TR: turkey,
    TM: turkmenistan,
    TC: turksAndCaicosIslands,
    TV: tuvalu,
    UG: uganda,
    UA: ukraine,
    MK: northMacedonia,
    EG: egypt,
    GB: unitedKingdom,
    GG: guernsey,
    JE: jersey,
    IM: isleOfMan,
    TZ: tanzania,
    US: unitedStates,
    VI: virginIslandsUs,
    BF: burkinaFaso,
    UY: uruguay,
    UZ: uzbekistan,
    VE: venezuela,
    WF: wallisAndFutuna,
    WS: samoa,
    YE: yemen,
    ZM: zambia,
  };

  const buildingList: Array<DropdownOption> = [];
  crmCountriesOrRegionsList?.forEach(countryOrRegion => {
    const countryId = String(countryOrRegion.id);
    const isoCode = countryCrmCodeToIso[countryId] ?? countryId.toUpperCase();
    buildingList.push({
      value: countryOrRegion.id,
      label: countryIsoToLocalizedName[isoCode] ?? countryOrRegion.value,
    });
  });

  const marketInfo = useSelector(getMarketInfo);
  buildingList.sort((x, y) =>
    x.label.trim().toLowerCase().localeCompare(y.label.trim().toLowerCase(), marketInfo.locale)
  );
  if (includeSelect) {
    buildingList.unshift({ value: "", label: select });
  }
  return buildingList;
};

export const useCountriesOrRegionsList = (): Array<DropdownOption> => {
  const crmCountriesOrRegionsList = useSelector(getCountriesOrRegionsList);
  return useLocalizedCountriesOrRegionsList(crmCountriesOrRegionsList);
};
